import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import Checkbox from 'components/Shared/Inputs/Checkbox';
import SegmentIO from 'reporting/SegmentIO';
import WavefrontReporter from 'reporting/wavefront/WavefrontReporter';
import { colors, fontSize } from 'styles/cp';

const wavefrontReporter = WavefrontReporter.getInstance();

type SaveToMerchantWalletCheckboxProps = {
  onCheckboxChange: () => void;
  isCheckboxChecked: boolean;
  companyName: string;
};

const SaveToMerchantWalletCheckbox = ({
  onCheckboxChange,
  isCheckboxChecked,
  companyName,
}: SaveToMerchantWalletCheckboxProps) => {
  useEffect(() => {
    SegmentIO.cardOnFileSaveMerchantWalletCheckboxViewed();
    wavefrontReporter.trackSaveMerchantWalletCheckboxViewed();
  }, []);

  return (
    <React.Fragment>
      <div className="save-to-c1-wallet-checkbox-container-wrapper">
        <div className="save-to-c1-wallet-checkbox-container">
          <div className="save-to-c1-wallet-checkbox-content">
            <div className="save-to-c1-wallet-checkbox-separator">
              <div className="save-to-c1-wallet-checkbox-icon">
                <Checkbox
                  checked={isCheckboxChecked}
                  onChange={onCheckboxChange}
                  disabled={false}
                  type="primary"
                />
              </div>
              <div className="save-to-c1-wallet-checkbox-text">
                <div className="save-to-c1-wallet-checkbox-text-title">
                  <FormattedMessage
                    id="CARD_ON_FILE_SAVE_TO_C1_WALLET_CHECKBOX_TITLE"
                    defaultMessage="Allow business to charge this payment method for future transactions"
                  />
                </div>
                <div className="save-to-c1-wallet-checkbox-text-description">
                  <FormattedMessage
                    id="CARD_ON_FILE_SAVE_TO_C1_WALLET_CHECKBOX_DESCRIPTION"
                    defaultMessage="You authorize Intuit to securely store this payment method for Grasshopper to charge for future transactions. You can delete it anytime."
                    values={{
                      companyName,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .save-to-c1-wallet-checkbox-container-wrapper {
          padding: 0 0 16px 0;
        }
        .save-to-c1-wallet-checkbox-container {
          display: flex;
          max-width: 528px;
          padding: 16px;
          align-items: flex-start;
          gap: 12px;
          flex-shrink: 0;
          align-self: stretch;
          border-radius: 8px;
          border: 1px solid ${colors.gray04};
        }
        .save-to-c1-wallet-checkbox-content {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          gap: 16px;
          align-self: stretch;
        }
        .save-to-c1-wallet-checkbox-separator {
          display: flex;
          align-items: flex-start;
          gap: 12px;
        }
        .save-to-c1-wallet-checkbox-text {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 4px;
        }
        .save-to-c1-wallet-checkbox-text-title {
          color: ${colors.gray};
          font-family: 'AvenirNextforINTUIT-Medium';
          font-size: 13px;
          font-style: normal;
          font-weight: 500;
          line-height: 130%;
        }
        .save-to-c1-wallet-checkbox-text-description {
          color: ${colors.gray02};
          font-size: ${fontSize.xxs};
          font-style: normal;
          font-weight: 400;
          line-height: 130%;
        }
        .save-to-c1-wallet-checkbox-icon {
          display: flex;
          flex: 0;
        }
        .save-to-c1-wallet-checkbox-icon :global(.cpCheckbox) {
          border-radius: 4px;
        }
        @media screen and (max-width: 768px) {
          :global(.cpButton--jumbo) {
            display: flex;
            flex-wrap: wrap;
            height: unset !important;
            min-height: 48px !important;
            border-radius: 4px !important;
            font-size: 16px !important;
            font-weight: 600 !important;
            white-space: normal !important;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default SaveToMerchantWalletCheckbox;
